import React, { Component } from "react";

import { Wrapper } from "app/NativeComponents/common";

import MessageHeader from "./MessageHeader";
import ToTextMessage from "./ToTextMessage";
import FromTextMessage from "./FromTextMessage";
import MessageNote from "./MessageNote";
import moment from "moment";
import { renderDate } from "app/NativeActions";
class Conversation extends Component {
  renderClosingHeader() {
    const {
      is_latest_conversation,
      conversation: {
        closed_conversation,
        closed_conversation_date,
        awaiting_response_lock_out,
        timezone_lock_out,
        lead_phone_number
      }
    } = this.props;
    if (is_latest_conversation) {
      if (lead_phone_number) {
        if (lead_phone_number.blocked == 1) {
          return (
            <MessageHeader
              colors={this.props.colors}
              message_header_text={
                "Number blocked. You cannot send text messages to this number unless the user re-subscribes."
              }
            />
          );
        }
        if (lead_phone_number.landline == 1) {
          return (
            <MessageHeader
              colors={this.props.colors}
              message_header_text={"This phone number is a landline."}
            />
          );
        }

        if (lead_phone_number.is_litigator == 1) {
          return (
            <MessageHeader
              colors={this.props.colors}
              message_header_text={"This number is a known litigator."}
            />
          );
        }

        if (lead_phone_number.do_not_call == 1) {
          return (
            <MessageHeader
              colors={this.props.colors}
              message_header_text={'This number is on the "Do not call list".'}
            />
          );
        }

        if (lead_phone_number.bad_phone == 1) {
          return (
            <MessageHeader
              colors={this.props.colors}
              message_header_text={"This number was marked as wrong."}
            />
          );
        }

        if (lead_phone_number.expected_undeliverable) {
          return (
            <MessageHeader
              colors={this.props.colors}
              message_header_text={"The carrier blocked this number as spam."}
            />
          );
        }
      }

      if (awaiting_response_lock_out) {
        return (
          <MessageHeader
            colors={this.props.colors}
            message_header_text={
              "Conversation Locked. You must wait for the lead to respond or wait 7 days."
            }
          />
        );
      }

      if (timezone_lock_out || lead_phone_number.timezone_lock_out) {
        return (
          <MessageHeader
            colors={this.props.colors}
            message_header_text={
              "The current time is outside of the TCPA hours for this area."
            }
          />
        );
      }

      if (closed_conversation) {
        return (
          <MessageHeader
            colors={this.props.colors}
            message_header_text={
              "Conversation closed on " +
              renderDate(closed_conversation_date, true)
            }
          />
        );
      }
    }
  }

  renderNewMessageHeader(should_render_header, last_message_date) {
    if (should_render_header) {
      return (
        <MessageHeader
          colors={this.props.colors}
          message_header_text={renderDate(last_message_date, true)}
        />
      );
    }
  }

  renderConversationHeader() {
    if (this.props.is_first_conversation) {
      return (
        <MessageHeader
          colors={this.props.colors}
          message_header_text={
            "Conversation started " +
            renderDate(
              moment(this.props.conversation.date_created).format(),
              true
            )
          }
        />
      );
    }
  }

  render() {
    const { colors, conversation } = this.props;

    let last_message_date = conversation.date_created;

    return (
      <Wrapper>
        {this.renderConversationHeader()}
        {conversation.text_messages &&
          conversation.text_messages
            .slice(0)
            .reverse()
            .map((message, i) => {
              let should_render_header = false;
              if (
                moment(message.date_created) >
                moment(last_message_date).add(1, "day")
              ) {
                should_render_header = true;
                last_message_date = message.date_created;
              }

              if (message.message_type == "note") {
                return (
                  <Wrapper key={i}>
                    {this.renderNewMessageHeader(
                      should_render_header,
                      last_message_date
                    )}
                    <MessageNote
                      colors={colors}
                      message_text={message.message_text}
                      date_created={message.date_created}
                      sending_message={false}
                      user={{
                        image: message.user_image,
                        email: message.user_email,
                        firstname: message.user_firstname,
                        lastname: message.user_lastname
                      }}
                    />
                  </Wrapper>
                );
              }

              if (message.incoming_message) {
                return (
                  <Wrapper key={i}>
                    {this.renderNewMessageHeader(
                      should_render_header,
                      last_message_date
                    )}
                    <FromTextMessage
                      message_id={message.text_message_id}
                      conversation_id={conversation.id}
                      lead_id={conversation.lead_id}
                      token={this.props.token}
                      colors={colors}
                      read_message={message.read_message}
                      message_text={message.message_text}
                      media={message.media}
                      date_created={message.date_created}
                      readTextMessage={this.props.readTextMessage}
                    />
                  </Wrapper>
                );
              }

              return (
                <Wrapper key={i}>
                  {this.renderNewMessageHeader(
                    should_render_header,
                    last_message_date
                  )}

                  <ToTextMessage
                    colors={colors}
                    message_text={message.message_text}
                    stop_message_text={message.stop_message_text}
                    from_phone_number={
                      conversation.team_phone_number
                        ? conversation.team_phone_number.phone_number
                        : null
                    }
                    date_created={message.date_created}
                    sending_message={message.sending_message}
                    user={{
                      image: message.user_image,
                      email: message.user_email,
                      firstname: message.user_firstname,
                      lastname: message.user_lastname
                    }}
                    failed_to_send={
                      message.message_status == "failed_to_send" ? true : false
                    }
                    failure_message={message.failure_message}
                  />
                </Wrapper>
              );
            })}
        {this.renderClosingHeader()}
      </Wrapper>
    );
  }
}

export default Conversation;
